import React, { useState } from 'react';
import '../styles/UpdatePaymentModal.css';

const UpdatePaymentModal = ({ onClose }) => {
  const [cardNumber, setCardNumber] = useState('');
  const [nameOnCard, setNameOnCard] = useState('');
  const [expirationDate, setExpirationDate] = useState('');
  const [savedCards, setSavedCards] = useState([
    { number: '4242', name: 'No Name', expiry: '10/2029' }
  ]);
  const [selectedCard, setSelectedCard] = useState('4242'); // Default to first card

  // Add this function to format credit card number
  const formatCreditCard = (value) => {
    if (!value) return value;
    // Remove all non-digit characters
    const v = value.replace(/\D/g, '');
    // Add space after every 4 digits
    const matches = v.match(/\d{4,16}/g);
    const match = matches && matches[0] || '';
    const parts = [];

    for (let i = 0, len = match.length; i < len; i += 4) {
      parts.push(match.substring(i, i + 4));
    }

    if (parts.length) {
      return parts.join(' ');
    } else {
      return value;
    }
  };

  // Add expiration date formatting
  const formatExpirationDate = (value) => {
    if (!value) return value;
    const v = value.replace(/\D/g, '');
    if (v.length >= 2) {
      return v.slice(0, 2) + '/' + v.slice(2, 6);
    }
    return v;
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Get last 4 digits of card
    const last4 = cardNumber.replace(/\D/g, '').slice(-4);
    
    // Add new card to saved cards
    setSavedCards([
      ...savedCards,
      {
        number: last4,
        name: nameOnCard,
        expiry: expirationDate
      }
    ]);

    // Reset form
    setCardNumber('');
    setNameOnCard('');
    setExpirationDate('');
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="payment-modal-content" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Update Payment Information</h3>
          <div className="modal-subtitle">Your credit and debit cards</div>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>
        
        <div className="payment-section">
          <div className="existing-cards">
            <div className="card-headers">
              <span>Card</span>
              <span>Name on card</span>
              <span>Expires</span>
            </div>
            {savedCards.map((card, index) => (
              <div className="card-row" key={index}>
                <div className="card-select">
                  <input 
                    type="radio"
                    name="card-select"
                    checked={selectedCard === card.number}
                    onChange={() => setSelectedCard(card.number)}
                  />
                </div>
                <span className="card-number">Visa {card.number}</span>
                <span className="card-name">{card.name}</span>
                <span className="card-expiry">{card.expiry}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="add-card-section">
          <h3>Add a credit or debit card</h3>
          <form className="add-card-form" onSubmit={handleSubmit}>
            <input 
              type="text" 
              placeholder="Name on Card" 
              className="form-input"
              value={nameOnCard}
              onChange={(e) => setNameOnCard(e.target.value)}
            />
            <input type="text" placeholder="Billing Address" className="form-input" />
            <div className="location-inputs">
              <input type="text" placeholder="City" className="form-input city" />
              <input type="text" placeholder="State" className="form-input state" />
              <input type="text" placeholder="ZIP" className="form-input zip" />
            </div>
            <div className="card-input">
              <span className="card-icon">💳</span>
              <input 
                type="text" 
                placeholder="Card number" 
                className="form-input"
                value={cardNumber}
                onChange={(e) => {
                  const formatted = formatCreditCard(e.target.value);
                  setCardNumber(formatted);
                }}
                maxLength="19"
              />
            </div>
            <div className="expiration-input">
              <input 
                type="text" 
                placeholder="MM/YYYY" 
                className="form-input"
                value={expirationDate}
                onChange={(e) => {
                  const formatted = formatExpirationDate(e.target.value);
                  setExpirationDate(formatted);
                }}
                maxLength="7"
              />
            </div>
          </form>
        </div>

        <div className="update-billing-container">
          <button 
            className="update-billing-btn"
            onClick={handleSubmit}
          >
            UPDATE BILLING
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpdatePaymentModal; 